import React, { useEffect, useRef } from "react";
import * as QuickSightEmbedding from "amazon-quicksight-embedding-sdk";
import { encrypt } from "../utils/cipher";
import SecureLS from "secure-ls";
import axios from "axios";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const QuickSightAnalytics = () => {
  const ls = new SecureLS();
  const embeddingContainer = useRef(null);
  const token = ls.get('token');
  const analyticsPayload = {
    token: token,
  }; 
  const encryptedPayload = encrypt(analyticsPayload);
  const navBarState = useSelector(
    (state) => state.selectedDimensions.handelNavBarState
  );
  const navigate = useNavigate();

  console.log("nav bar state  in quick sight", navBarState);
  useEffect(() => {
    const embedDashboard = async () => {
      try {
        const response = await axios
          .post(`${process.env.REACT_APP_BACKEND_URL}/analytics`, {
            payload: encryptedPayload,
          })
          .catch((err) => {
            console.log("error", err);
            if (err.response?.data?.sucess == false) {
              ls.clear();
              Swal.fire({
                title: "Error",
                text: "Session Expired",
                icon: "error",
              });
              navigate("/");
            }
            console.log(
              "error found in quicksight analytics page",
              err.response.data.sucess
            );
          });

        const embedUrl = response.data.EmbedUrl;
        const options = {
          url: embedUrl,
          container: embeddingContainer.current,
        //   scrolling: 'yes',
          // height: '700px',
          // width: '1000px',
        };

        // Create an embedding context
        const embeddingContext = await QuickSightEmbedding.createEmbeddingContext();
        const dashboard = await embeddingContext.embedDashboard(options);
         console.log("dashboard",dashboard);
        // Set up the event listener using the new dashboard instance
        dashboard.on('load', (payload) => {
          console.log('Dashboard loaded successfully!', payload);
        });

      } catch (error) {
        console.error('Error embedding the QuickSight dashboard:', error);
        // Swal.fire('Error', 'Failed to load the QuickSight dashboard.', 'error');
      }
    };

    embedDashboard();
  }, [encryptedPayload]);

  useEffect(()=>{

    setInterval(async() => {
      console.log("HI there times up for now!!, let's check for expiry", new Date());
      //checking how??????????????????
      const response = await axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/analytics`, {
        payload: encryptedPayload,
      })
      .catch((err) => {
        if (err.response?.data?.sucess == false) {
          ls.clear();
          Swal.fire({
            title: "Error",
            text: "Session Expired",
            icon: "error",
          });
          navigate("/");
        }
        console.log(
          "error found in quicksight analytics page",
          err.response.data.sucess
        );
      });

      console.log("no error found", response.data.Status)
    }, 900000 );                                        //15 minutes timer
  }, [])

  return (
    <div style={{ marginTop: '4.1rem' }}>
      {
        navBarState ?(<div
          ref={embeddingContainer}
          style={{
            height: '100vh',
            // width: '89vw',  
            // border: '1px solid #red',
            borderRadius: '4px',
          }}
        />):(<div
          ref={embeddingContainer}
          style={{
            height: '100vh',
            // width: '95vw',  
            // border: '1px solid #red',
            borderRadius: '4px',
            // background:"red"
          }}
        />)
      }
      
    </div>
  );
};

export default QuickSightAnalytics;
